import { SVGProps } from "react";
const PedagogueCertificateText = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="842"
    height="112"
    viewBox="0 0 842 112"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M841.986 73.4545C841.986 49.0274 823.263 30.7488 797.946 30.7488C770.546 30.7488 751.823 49.3543 751.823 73.4545C751.823 97.5547 770.2 116.16 799.859 116.16C816.323 116.16 829.165 110.499 837.658 99.4953L816.852 88.332C813.386 91.8931 807.315 94.4805 800.205 94.4805C790.674 94.4805 782.696 91.5662 779.399 83.1572H840.962C841.654 80.083 842 76.8487 842 73.4545H841.986ZM778.87 65.0386C781.292 56.7896 787.885 52.2617 797.769 52.2617C805.571 52.2617 813.372 55.6559 816.147 65.0386H778.87Z"
      fill="url(#paint0_linear_2368_502)"
      fillOpacity="0.3"
    />
    <path
      d="M719.939 77.7125C719.939 89.0357 713.628 94.1409 704.485 94.1409C696.514 94.1409 690.033 89.5157 690.033 79.6252V34.1652H665.105V83.1376C665.105 104.671 679.394 116.161 696.183 116.161C707.154 116.161 715.456 112.336 719.939 106.431V113.929H744.868V34.1652H719.939V77.7125Z"
      fill="url(#paint1_linear_2368_502)"
      fillOpacity="0.3"
    />
    <path
      d="M338.004 40.6121C332.257 34.4636 323.736 30.7425 312.073 30.7425C289.277 30.7425 270.476 49.348 270.476 73.4482C270.476 97.5484 289.277 116.154 312.073 116.154C323.729 116.154 332.257 112.433 338.004 106.284V113.886H364.112V33.0099H338.004V40.6121ZM317.29 93.1874C305.281 93.1874 296.584 85.5852 296.584 73.4551C296.584 61.325 305.281 53.7229 317.29 53.7229C329.299 53.7229 338.004 61.325 338.004 73.4551C338.004 85.5852 329.306 93.1874 317.29 93.1874Z"
      fill="url(#paint2_linear_2368_502)"
      fillOpacity="0.3"
    />
    <path
      d="M238.41 40.1809C232.882 33.9976 224.664 30.2557 213.439 30.2557C191.482 30.2557 173.388 48.9655 173.388 73.2048C173.388 97.4441 191.489 116.154 213.439 116.154C224.664 116.154 232.882 112.412 238.41 106.229V113.873H263.55V0H238.41V40.1809ZM218.472 93.0553C206.908 93.0553 198.528 85.4114 198.528 73.2048C198.528 60.9982 206.908 53.3543 218.472 53.3543C230.037 53.3543 238.417 60.9982 238.417 73.2048C238.417 85.4114 230.037 93.0553 218.472 93.0553Z"
      fill="url(#paint3_linear_2368_502)"
      fillOpacity="0.3"
    />
    <path
      d="M127.58 30.7488C101.239 30.7488 83.2291 49.3543 83.2291 73.4545C83.2291 97.5547 100.9 116.16 129.408 116.16C145.244 116.16 157.584 110.499 165.753 99.4953L145.745 88.332C142.413 91.8931 136.574 94.4805 129.74 94.4805C120.569 94.4805 112.902 91.5662 109.732 83.1572H168.916C169.579 80.083 169.918 76.8487 169.918 73.4545C169.918 49.0274 151.915 30.7488 127.573 30.7488H127.58ZM109.238 65.0386C111.575 56.7896 117.908 52.2617 127.41 52.2617C134.915 52.2617 142.413 55.6559 145.081 65.0386H109.238Z"
      fill="url(#paint4_linear_2368_502)"
      fillOpacity="0.3"
    />
    <path
      d="M45.0495 0H0V116.161H27.2019V79.6524H45.0495C68.5096 79.6524 86.6961 61.8954 86.6961 39.8262C86.6961 17.7569 68.5096 0 45.0495 0ZM45.0495 54.7593H27.2019V24.8931H45.0495C53.3802 24.8931 59.5012 31.3616 59.5012 39.8262C59.5012 48.2908 53.3802 54.7593 45.0495 54.7593Z"
      fill="url(#paint5_linear_2368_502)"
      fillOpacity="0.3"
    />
    <path
      d="M512.541 30.7488C487.535 30.7488 467.464 49.3543 467.464 73.4545C467.464 97.5547 487.535 116.16 512.541 116.16C537.548 116.16 557.626 97.5547 557.626 73.4545C557.626 49.3543 537.555 30.7488 512.541 30.7488ZM512.541 92.5399C501.485 92.5399 492.978 84.9377 492.978 73.4545C492.978 61.9712 501.485 54.3691 512.541 54.3691C523.597 54.3691 532.104 61.9712 532.104 73.4545C532.104 84.9377 523.604 92.5399 512.541 92.5399Z"
      fill="url(#paint6_linear_2368_502)"
      fillOpacity="0.3"
    />
    <path
      d="M420.753 31.6219C395.93 31.6219 376 50.0883 376 74.0146C376 97.9409 395.923 116.414 420.753 116.414C445.582 116.414 465.513 97.9478 465.513 74.0146C465.513 50.0813 445.589 31.6219 420.753 31.6219ZM420.753 92.7244C409.774 92.7244 401.331 85.1778 401.331 73.7711C401.331 62.3644 409.781 54.8179 420.753 54.8179C431.724 54.8179 440.174 62.3644 440.174 73.7711C440.174 85.1778 431.731 92.7244 420.753 92.7244Z"
      fill="url(#paint7_linear_2368_502)"
      fillOpacity="0.3"
    />
    <path
      d="M440.13 123.29C440.121 134.577 431.799 142.147 420.898 142.293C410.004 142.439 401.533 135.099 401.323 123.812L376.007 124.154L376.008 124.175C376.225 148.121 396.3 166.328 421.108 165.996C445.924 165.662 465.665 146.914 465.454 122.968L465.454 122.947L440.137 123.289L440.13 123.29Z"
      fill="url(#paint8_linear_2368_502)"
      fillOpacity="0.3"
    />
    <path
      d="M630.936 37.8089C624.589 34.6303 617.325 32.8498 609.58 32.8498C584.573 32.8498 564.502 51.4552 564.502 75.5554C564.502 99.6556 584.573 118.261 609.58 118.261C617.325 118.261 624.589 116.474 630.936 113.302V124.236C630.322 134.905 622.111 141.888 611.557 141.888C601.002 141.888 592.248 134.439 592.135 123.158H566.797C566.797 123.158 566.797 123.172 566.797 123.179C566.797 147.105 586.72 165.578 611.55 165.578C636.379 165.578 655.702 147.647 656.281 124.236H656.345V34.9363H630.929V37.8089H630.936ZM609.58 94.6408C598.524 94.6408 590.017 87.0387 590.017 75.5554C590.017 64.0722 598.524 56.47 609.58 56.47C620.636 56.47 629.143 64.0722 629.143 75.5554C629.143 87.0387 620.643 94.6408 609.58 94.6408Z"
      fill="url(#paint9_linear_2368_502)"
      fillOpacity="0.3"
    />
    <defs>
      <linearGradient
        id="paint0_linear_2368_502"
        x1="420.991"
        y1="-112.735"
        x2="420.991"
        y2="124.898"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="rgb(var(--pd-ink))" />
        <stop offset="1" stopColor="rgb(var(--pd-slate))" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_2368_502"
        x1="420.991"
        y1="-112.735"
        x2="420.991"
        y2="124.898"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="rgb(var(--pd-ink))" />
        <stop offset="1" stopColor="rgb(var(--pd-slate))" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_2368_502"
        x1="420.991"
        y1="-112.735"
        x2="420.991"
        y2="124.898"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="rgb(var(--pd-ink))" />
        <stop offset="1" stopColor="rgb(var(--pd-slate))" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_2368_502"
        x1="420.991"
        y1="-112.735"
        x2="420.991"
        y2="124.898"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="rgb(var(--pd-ink))" />
        <stop offset="1" stopColor="rgb(var(--pd-slate))" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_2368_502"
        x1="420.991"
        y1="-112.735"
        x2="420.991"
        y2="124.898"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="rgb(var(--pd-ink))" />
        <stop offset="1" stopColor="rgb(var(--pd-slate))" stop-opacity="0" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_2368_502"
        x1="420.991"
        y1="-112.735"
        x2="420.991"
        y2="124.898"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="rgb(var(--pd-ink))" />
        <stop offset="1" stopColor="rgb(var(--pd-slate))" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="paint6_linear_2368_502"
        x1="420.991"
        y1="-112.735"
        x2="420.991"
        y2="124.898"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="rgb(var(--pd-ink))" />
        <stop offset="1" stopColor="rgb(var(--pd-slate))" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="paint7_linear_2368_502"
        x1="420.991"
        y1="-112.735"
        x2="420.991"
        y2="124.898"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="rgb(var(--pd-ink))" />
        <stop offset="1" stopColor="rgb(var(--pd-slate))" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="paint8_linear_2368_502"
        x1="420.991"
        y1="-112.735"
        x2="420.991"
        y2="124.898"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="rgb(var(--pd-ink))" />
        <stop offset="1" stopColor="rgb(var(--pd-slate))" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="paint9_linear_2368_502"
        x1="420.991"
        y1="-112.735"
        x2="420.991"
        y2="124.898"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="rgb(var(--pd-ink))" />
        <stop offset="1" stopColor="rgb(var(--pd-slate))" stopOpacity="0" />
      </linearGradient>
    </defs>
  </svg>
);
export default PedagogueCertificateText;
